import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://81683979e8b5468fb912b44f58adafe5@o4505238883336192.ingest.sentry.io/4505239208132608",
  integrations: [new Sentry.Replay()],
  // Session Replay
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});
